import importer from 'common/importer'

const { mulesoftReq: req } = importer('APIs', null)
/**
 * Login Callout 1 Get Authentication Session Token From Apigee
 * @param {String} username REQUIRED
 * @param {String} password REQUIRED
 * @param {String} relayState default: /myapp/some/deep/link/i/want/to/return/to
 * @param {String} headers.client_secret default: d1007A6768Aa4A20a7c04839c518D5C4
 * @param {String} headers.client_id default: ef41182a19234a5ca6540d2adaacbff4
 * @param {Boolean} options.multiOptionalFactorEnroll default: false
 * @param {Boolean} options.warnBeforePasswordExpired  default: false
 */
const main = (
  username,
  password,
  relayState = '/myapp/some/deep/link/i/want/to/return/to',
  options = {
    multiOptionalFactorEnroll: false,
    warnBeforePasswordExpired: false
  }
) => {
  const data = {
    username: username.toLowerCase(),
    password,
    relayState,
    options
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    }
  }
  return req.post('/authn', data, config)
  //return req.post('/authenticate', data, config)
}

export default main
